// Autogenerated locales - do not modify
/* tslint:disable quotemark variable-name */
export const PROFILE_WAS_SAVED = "Profil byl ulo\u017een.";
